export default __webpack_public_path__ + "static/advances-b74118e368ef5bb5d6f26e1311ae102b.webm";